import { Component, ElementRef, ViewChild } from '@angular/core';
import { AuthenticationService } from '../../core/services/authentication.service';
import { EmittersService } from '../../core/utils/emitters.service';

@Component({
	selector: 'app-inactivity-modal',
	templateUrl: './inactivity-modal.component.html',
	styleUrls: ['./inactivity-modal.component.scss']
})
export class InactivityModalComponent {
	@ViewChild('dismiss') dismiss!: ElementRef;

	timerValue!: number;
	intervalId: any;

	timer!: string;
	constructor(private _emittersService: EmittersService, private _authenticationService: AuthenticationService) {
		_emittersService.inactivityStartCount.subscribe(() => this._resetTimer());
	}

	restart(): void {
		clearInterval(this.intervalId);
		this._emittersService.inactivityRestartCount.emit();
	}

	private _startTimer(): void {
		this.timerValue = 60; // 1 minutos en segundos (1 * 60)
		this.intervalId = setInterval(() => {
			if (this.timerValue > 0) {
				const minutes = Math.floor(this.timerValue / 60); // Calculamos los minutos
				const seconds = this.timerValue % 60; // Calculamos los segundos
				this.timer = `${this._pad(minutes)}:${this._pad(seconds)}`; // Mostramos  formato minutos:segundos
				this.timerValue--;
			} else {
				clearInterval(this.intervalId); // Detenemos el temporizador cuando llega a 0
				this.dismiss.nativeElement.click();
				this._authenticationService.signout();
			}
		}, 1000); // Intervalo de 1 segundo
	}

	private _resetTimer(): void {
		clearInterval(this.intervalId); // Limpiamos cualquier intervalo anterior
		this._startTimer(); // Reiniciamos el temporizador
	}

	private _pad(value: number): string {
		return value < 10 ? '0' + value : value.toString();
	}
}
